import State from './State.js';
import ScoreCalculator from './ScoreCalculator.js';
export default class StateShowDealerHand extends State {
    constructor(context) {
        super(context);
        this.name = 'showDealerHand';
        this.calc = new ScoreCalculator();
    }
    setup() {

        this.scoreDealersHand();

        
    }
    action(command, value, player) {
        switch (command) {
            case "nextShow": return this.next(player); break;
            case "next": return this.next(player); break;
            default: return this.unknownCommand(command, value, player);
        }
    }
    getActions(player) {
        let actions = [];
        actions.push({ command: "nextShow", value: null });
        actions.push({ command: "next", value: null });
        return actions;
    }
    next() {
        this.context.setState("showCrib");
        return true;
    }

 
   
    scoreDealersHand() {
        let dealer = this.context.dealer;
        if(!dealer) return;
        
        let dealerHandName = dealer == "player1" ? "handShow1" : "handShow2";
        let nonDealer = (dealer === "player1") ? "player2" : "player1";
        let nonDealerHandName = nonDealer == "player1" ? "handShow1" : "handShow2";

        //message
        this.context.messagePlayer1 = "";
        this.context.messagePlayer2 = "";
 
        if(dealer === "player1")this.context.messagePlayer1 = "Hand";
        if(dealer === "player2")this.context.messagePlayer2 = "Hand";

        // //clear all non dealers card
        // let nonDealerHand = this.context.getPile(nonDealerHandName);
        // for (let i = 0; i < nonDealerHand.length; i++) {
        //     let card = nonDealerHand[i];
        //     card.showfront = true;
        //     this.context.addToPile(card, "deck", "system");
        // }

        //pull cards back from discard pile and place back in hand to score
        //let playedCards = this.context.getPile("played");
        let playersCards = this.context.getCardsByOwner2(dealer);
        for (let i = 0; i < playersCards.length; i++) {
            let card = playersCards[i];
            card.showfront = false;
            this.context.addToPile(card, dealerHandName, "system");
        }
        this.context.sortPile(dealerHandName);

        //let dealersHand = this.context.getPile(dealerHandName);


        //starter card
        let starterCard = this.context.getStarterCard();

        //The dealer scores his hand last
        let pointsDealersHand = this.calc.scoreHand(starterCard, playersCards, dealer);
        this.context.awardPointsArray(pointsDealersHand);

        //todo: log player hand

        //get total points for array
        let totalPoints = pointsDealersHand.reduce(function (total, pointLog) {
            return total + pointLog["points"];
        }, 0);

        //send totalPoints as message for UI to show
        this.context.sendEvent("handPoints", totalPoints + " Hand", dealer);

        this.context.sendEvent("message", " Dealer's Hand", dealer);
        this.step = "scoreDealersHand";
    }
   
    unknownCommand(command, value, player) {
        this.context.unknownCommand(command, null, player);
    }

}